import { render, staticRenderFns } from "./fundsWater.vue?vue&type=template&id=6800dcf6&scoped=true&"
import script from "./fundsWater.vue?vue&type=script&lang=js&"
export * from "./fundsWater.vue?vue&type=script&lang=js&"
import style0 from "./fundsWater.vue?vue&type=style&index=0&id=6800dcf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800dcf6",
  null
  
)

export default component.exports